import { AfterViewInit, ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { DatafoxDevice } from '../../models/datafox-device.model';
import { FileUploadType } from '../../models/fileUploadType.enum';
import { FileUploadService } from '../../services/fileupload.service';
import { TerminalsService } from '../../services/terminals.service';

@Component({
    selector: 'upload-modal-dialog',
    templateUrl: 'upload-modal-dialog.component.html',
    styleUrls: ['./upload.component.scss'],
    standalone: false
})

export class UploadSetupModalDialogComponent implements AfterViewInit {

  @ViewChild("form", { static: false }) public form: NgForm;
  public titleHeader: string = null;
  public title: string;
  public accept: boolean = false;
  public selectedDevices: DatafoxDevice[] = new Array<DatafoxDevice>();

  public selectedFileUploadType: FileUploadType = FileUploadType.Firmware;

  constructor(public dialogRef: MatDialogRef<UploadSetupModalDialogComponent>, private fileUploadService: FileUploadService,
    private terminalService: TerminalsService, private cdr: ChangeDetectorRef) {
  }

  ngAfterViewInit(): void {
    this.updateTitle();
    this.cdr.detectChanges();
  }

  public get allTerminals(): DatafoxDevice[] {
    if (this.terminalService.terminalsSearchList?.length) {
      return this.terminalService.terminalsSearchList;
    }
    return this.terminalService.allTerminals;
  }

  public updateFileUploadType(event: MatSelectChange) {
    // console.log('updateFileUploadType => ', event);
    let number: number = event.value;
    this.selectedFileUploadType = number;
    this.updateTitle();
  }

  public updateTitle() {
    if (this.selectedFileUploadType == FileUploadType.Firmware) {
      this.title = "Neue Firmware einspielen";
    } else if (this.selectedFileUploadType == FileUploadType.TerminalSetupFile) {
      this.title = "Neues Update einspielen";
    } else if (this.selectedFileUploadType == FileUploadType.TlsRootCertificate) {
      this.title = "Neues Zertifikat einspielen";
    }
  }

  public closeDialog() {
    this.dialogRef.close();
  }

  public fileToUpload: File = null;
  public handleFile(files: FileList) {
    this.fileToUpload = files.item(0);
  }

  public get isValid() {
    return this.form?.valid && this.fileToUpload && this.selectedDevices?.length;
  }

  public isLoading: boolean = false;
  public save() {
    this.accept = true;
    if (this.form.valid && this.fileToUpload && this.selectedDevices?.length) {
      this.isLoading = true;
      this.fileUploadService.uploadSetup(this.fileToUpload, this.selectedDevices, this.selectedFileUploadType).then(ok => {
        this.isLoading = false;
        this.closeDialog();
      }).catch(error => {
        this.isLoading = false;
      });
    }
  }

  public selectAllTerminals(event: MouseEvent) {
    event.stopPropagation();
    if (this.allTerminalsSelected) {
      this.selectedDevices = new Array<DatafoxDevice>();
    } else {
      this.selectedDevices = [...this.allTerminals];
    }
  }

  public get allTerminalsSelected(): boolean {
    return this.allTerminals?.length == this.selectedDevices?.length;
  }

  public compareFn(obj1, obj2) {
    return obj1 && obj2 ? obj1.id === obj2.id : obj1 === obj2;
  }

  public trackByFn(index, item) {
    return index; // or item.id
  }
}
